import { Auth } from './auth';
import { User } from './user';
import { Trading } from './trading';
import { Category } from './category';
import { Instrument } from './instrument';
import { MarketData } from './marketData';
import { Alert } from './alert';
import { Payment } from './payment';

export type { ICategoryBE } from './category/models/category';
export type { ICreateAlertBody, IAlertFE } from './alert/models';

export type {
  IGetAuthRefreshTokenBE,
  IGetAuthTokenParams,
  IGetAuthTokenBE,
  IGetAuthRefreshTokenParams,
  IGlobalSignOutBEParams,
  ISignUpBody,
  IChangePasswordParams,
  ISsoParams,
} from './auth/models/token';

export type {
  IInstrumentDetailsBE,
  IInstrumentBE,
  IOrderDetailsBE,
  ISearchInstrumentBE,
  IInstrumentItems,
  ITradingHours,
  IGetInstrumentsBody,
} from './instrument/models/instrument';

export type {
  ITimeBE,
  ICandleData,
  ICandleBarBE,
  IIndicators,
} from './marketData/models';

export type {
  TProtectionType,
  TPlaceOrderType,
  TPlaceOrderSide,
} from './trading/models';
export type {
  IOrderItemsBE,
  IOrderBE,
  IOrderMetricsBE,
  IOrderMetricsFE,
  IEditOrderParams,
} from './trading/models/ordersMetrics';
export type {
  IPositionItemsBE,
  IPositionBE,
  IPositionMetricsBE,
  IEditPositionParams,
  IClosePositionParams,
  IPositionMetricsFE,
} from './trading/models/positionsMetrics';
export type { IPlaceOrderBody } from './trading/models/placeOrder';
export type {
  IPositionParamsBE,
  IPositionHistoryBE,
  IPositionsHistoryBE,
} from './trading/models/positionsHistory';
export type {
  IRequiredMarginParams,
  IRequiredMarginBE,
} from './trading/models/requiredMargin';

export type {
  IUserPortfolio,
  IUserProfile,
  TComplianceStage,
} from './user/models';

export type {
  IMakeDepositBody,
  ITransactionsBE,
  ITransaction,
  ITransferHistoryBE,
  ITransfersHistoryBE,
  ITransferParamsBE,
  IPspsResponseData,
  IPspsProvider,
  IGetPspsParams,
  IPurchaseParamsBE,
  IPurchasesHistoryBE,
  IPurchaseHistoryBE,
} from './payment/models';

export type {
  ICostAndChargesCommissionsModel,
  ICostAndChargesBE,
  IGetCostAndChargesParams,
  ICostAndChargesRowProps,
  ICostAndChargesItem,
} from './trading/models/costAndCharges';

export type {
  IAccountStatementBE,
  IGetAccountStatementParams,
} from './trading/models/accountStatement';

export class Api {
  Auth = new Auth();
  User = new User();
  Trading = new Trading();
  Alert = new Alert();
  Category = new Category();
  Instrument = new Instrument();
  MarketData = new MarketData();
  Payment = new Payment();
}

export const api = new Api();
